import React from 'react'
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../firebase';
import appLogo from '../../images/logo.png';
import '../styles/login.css';
import Loader from 'react-loader-spinner';
import Modal from 'react-modal';
import modalStyle from '../styles/modal';

const INITIAL_STATE = {
    loading: false,
    email: '',
    password: '',
    error: {
        isShow: false,
        title: '',
        message: ''
    }
};

Modal.setAppElement('#root');
class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE };
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSignIn = (e) => {
        e.preventDefault();

        const { email, password } = this.state;
        const isInvalid = password === '' || email === '';

        if (!isInvalid) {
            this.setState({ loading: true });

            this.props.firebase
                .doSignInWithEmailAndPassword(email, password)
                .then(() => {
                    this.props.history.push("/");
                    this.setState({ ...INITIAL_STATE });
                })
                .catch(error => {
                    this.setState({ loading: false });
                    this.showErrorModal("Los datos introducidos son incorrectos");
                    console.log(error);
                });
        } else {
            this.showErrorModal("Los datos introducidos son incorrectos");
        }
    }

    showErrorModal = (message) => {
        this.setState({
            error: {
                isShow: true,
                title: 'Error',
                message: message
            }
        });
    }

    closeErrorModal = () => {
        this.setState({
            error: {
                isShow: false,
                title: '',
                message: ''
            }
        });
    }

    render() {
        const { loading, email, password, error } = this.state;
        const isInvalid = password === '' || email === '';

        return (
            <div className="mt-4 row justify-content-center align-items-center" >

                <form className="form-signin text-center" onSubmit={this.handleSignIn}>
                    <img className="mb-4" src={appLogo} alt="" width="96" height="96" />
                    <h1 className="h3 mb-3 font-weight-normal">Iniciar Sesión</h1>

                    <input onChange={this.handleChange} name="email" type="email" className="form-control" placeholder="Usuario" required="" />

                    <input onChange={this.handleChange} name="password" type="password" className="form-control mt-3" placeholder="Contraseña" required="" />

                    {(!loading) ?

                        <button disabled={isInvalid} className="mt-3 btn btn-lg btn-primary btn-block" type="submit">Acceder</button>

                        :
                        <div className="nav justify-content-center row">
                            <Loader className="mt-4"
                                type="ThreeDots"
                                color="#263238"
                                height={60}
                                width={60}
                                timeout={0} />
                        </div>
                    }

                    <p className="mt-5 mb-3 text-muted">© 2019-2020</p>
                </form>

                <Modal
                    isOpen={error.isShow}
                    contentLabel="Modal Example"
                    style={modalStyle}
                    onRequestClose={this.closeErrorModal}>
                    <div className="" style={{ minWidth: '300px', maxWidth: '400px' }}>
                        <h5 className="card-title">{error.title}</h5>
                        <p className="card-text text-break">{error.message}</p>

                        <div className="nav justify-content-end">
                            <button onClick={this.closeErrorModal} className="btn btn-sm btn-dark">Cerrar</button>
                        </div>
                    </div>

                </Modal>

            </div>
        );
    }
}


export default withRouter(withFirebase(Login));